import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import { Button, Row, Col, Table, Input, Label, Badge, Form, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Swal from "sweetalert2";
import axios from "axios";

// Catálogo de ubicaciones del almacén. Permite dar de alta nuevas.
// Regla: Rack = 1 tarima, Rumba = 50 tarimas, Sistema = sin límite.
function CatalogoUbicaciones() {
  const { user } = useContext(AuthContext);
  const URL_UBICACIONES = process.env.REACT_APP_URL_UBICACIONES;
  const URL_INVENTARIOS = process.env.REACT_APP_URL_INVENTARIOS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const headers = { Authorization: `Bearer: ${localStorage.getItem("app_token")}` };

  const [ubicaciones, setUbicaciones] = useState([]);
  const [search, setSearch] = useState("");
  const [soloOcupadas, setSoloOcupadas] = useState(false);
  const [pagina, setPagina] = useState(1);
  const POR_PAGINA = 100;

  // alta
  const [rack, setRack] = useState("");
  const [posicion, setPosicion] = useState("");
  const [nivel, setNivel] = useState("");
  const [reach, setReach] = useState("A");
  const [tipo, setTipo] = useState("Rack");
  const [validaBoton, setValidaBoton] = useState(true);
  // Contenido de una ubicacion (que articulos y cuantas piezas tiene)
  const [ubiVer, setUbiVer] = useState(null);
  const [contenido, setContenido] = useState([]);
  const [cargandoContenido, setCargandoContenido] = useState(false);

  function verContenido(u) {
    setUbiVer(u);
    setContenido([]);
    setCargandoContenido(true);
    axios
      .get(`${URL_INVENTARIOS}BuscaUbicaciones/${encodeURIComponent(u.nombre)}`, {
        headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
      })
      .then((r) => setContenido(r.data || []))
      .catch(() => setContenido([]))
      .finally(() => setCargandoContenido(false));
  }

  const cargar = () =>
    axios
      .get(`${URL_UBICACIONES}Ocupacion`, { headers })
      .then((r) => setUbicaciones(r.data || []))
      .catch((e) => console.log(e));

  useEffect(() => {
    cargar();
  }, []);

  // Nombre según la convención del layout: Rack-Posición-NivelReach (A-1-1A); rumbas RR0-1
  const nombreGenerado = useMemo(() => {
    const r = rack.trim().toUpperCase();
    if (!r) return "";
    if (tipo === "Rumba") return `${r}0-${nivel || 1}`;
    if (tipo === "Sistema") return r;
    return `${r}-${posicion || 1}-${nivel || 1}${(reach || "").toUpperCase()}`;
  }, [rack, posicion, nivel, reach, tipo]);

  const capacidad = tipo === "Rumba" ? 50 : tipo === "Sistema" ? 0 : 1;

  const filtradas = useMemo(() => {
    const s = search.trim().toUpperCase();
    return ubicaciones
      .filter((u) => !s || u.nombre.toUpperCase().includes(s) || (u.rack || "").toUpperCase() === s)
      .filter((u) => !soloOcupadas || u.tarimasUsadas > 0)
      .sort((a, b) => (a.nombre > b.nombre ? 1 : -1));
  }, [ubicaciones, search, soloOcupadas]);

  const totalPaginas = Math.max(1, Math.ceil(filtradas.length / POR_PAGINA));
  const pag = Math.min(pagina, totalPaginas);
  const visibles = filtradas.slice((pag - 1) * POR_PAGINA, pag * POR_PAGINA);

  const resumen = useMemo(() => {
    const t = ubicaciones.length;
    const oc = ubicaciones.filter((u) => u.tarimasUsadas > 0).length;
    const llenas = ubicaciones.filter((u) => u.llena).length;
    return { total: t, ocupadas: oc, llenas, libres: t - oc };
  }, [ubicaciones]);

  function guardar(e) {
    e.preventDefault();
    if (!nombreGenerado) {
      Swal.fire({ icon: "error", title: "Captura el rack" });
      return;
    }
    setValidaBoton(false);
    axios
      .post(
        URL_UBICACIONES,
        {
          nombre: nombreGenerado,
          rack: rack.trim().toUpperCase(),
          posicion: Number(posicion) || 0,
          nivel: Number(nivel) || 0,
          reach: tipo === "Rack" ? (reach || "").toUpperCase() : "",
          tipo,
          capacidadTarimas: capacidad,
        },
        { headers }
      )
      .then(() => {
        axios.post(URL_LOGS, { tipo: "Crear Ubicación", detalle: nombreGenerado, user: user.id }, { headers });
        Swal.fire("¡Listo!", `Ubicación ${nombreGenerado} creada`, "success");
        setRack(""); setPosicion(""); setNivel(""); setReach("A"); setTipo("Rack");
        setValidaBoton(true);
        cargar();
      })
      .catch((error) => {
        Swal.fire({ icon: "error", title: "No se pudo crear", text: `${error?.response?.data || ""}` });
        setValidaBoton(true);
      });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_inventarios ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button size="sm" href="/AcomodoUbicaciones" className="btn btn-danger">
                Regresar
              </Button>
            </Col>
          </Row>
          <h3 align="center">Catálogo de Ubicaciones</h3>
          <div align="center" style={{ fontSize: 13, color: "#64748b" }}>
            {resumen.total.toLocaleString("en-US")} ubicaciones · {resumen.libres.toLocaleString("en-US")} libres ·{" "}
            {resumen.ocupadas.toLocaleString("en-US")} ocupadas · {resumen.llenas.toLocaleString("en-US")} llenas
          </div>
          <br />

          <div className="card" style={{ padding: 12, background: "#f8fafc", marginBottom: 14 }}>
            <Form onSubmit={guardar}>
              <Row className="align-items-end">
                <Col md={2}>
                  <Label>Tipo</Label>
                  <Input bsSize="sm" type="select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
                    <option value="Rack">Rack (1 tarima)</option>
                    <option value="Rumba">Rumba (50 tarimas)</option>
                    <option value="Sistema">Sistema (sin límite)</option>
                  </Input>
                </Col>
                <Col md={2}>
                  <Label>Rack</Label>
                  <Input bsSize="sm" type="text" placeholder="A, B, Ñ, RR…" value={rack} onChange={(e) => setRack(e.target.value)} />
                </Col>
                {tipo === "Rack" ? (
                  <>
                    <Col md={1}>
                      <Label>Posición</Label>
                      <Input bsSize="sm" type="number" min="1" value={posicion} onChange={(e) => setPosicion(e.target.value)} />
                    </Col>
                    <Col md={1}>
                      <Label>Nivel</Label>
                      <Input bsSize="sm" type="number" min="1" value={nivel} onChange={(e) => setNivel(e.target.value)} />
                    </Col>
                    <Col md={1}>
                      <Label>Reach</Label>
                      <Input bsSize="sm" type="select" value={reach} onChange={(e) => setReach(e.target.value)}>
                        <option value="A">A</option>
                        <option value="B">B</option>
                      </Input>
                    </Col>
                  </>
                ) : tipo === "Rumba" ? (
                  <Col md={1}>
                    <Label>Número</Label>
                    <Input bsSize="sm" type="number" min="1" value={nivel} onChange={(e) => setNivel(e.target.value)} />
                  </Col>
                ) : null}
                <Col md={2}>
                  <Label>Se creará como</Label>
                  <Input bsSize="sm" type="text" value={nombreGenerado} disabled />
                </Col>
                <Col md={2}>
                  <Button size="sm" color="success" type="submit" disabled={!validaBoton}>
                    <i class="fas fa-plus"></i> Agregar
                  </Button>
                </Col>
              </Row>
            </Form>
          </div>

          <Row className="align-items-end">
            <Col md={3}>
              <Label>Buscar</Label>
              <Input bsSize="sm" type="text" placeholder="Ubicación o rack" value={search} onChange={(e) => { setSearch(e.target.value); setPagina(1); }} />
            </Col>
            <Col md={3}>
              <div className="d-flex align-items-center" style={{ height: 31 }}>
                <Input type="checkbox" checked={soloOcupadas} onChange={(e) => { setSoloOcupadas(e.target.checked); setPagina(1); }} style={{ position: "static", margin: "0 6px 0 0" }} />
                <span style={{ fontSize: 13 }}>Sólo ocupadas</span>
              </div>
            </Col>
            <Col
              md={6}
              style={{ fontSize: 13, color: "#64748b", display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 6, flexWrap: "wrap" }}
            >
              <span style={{ marginRight: 6 }}>{filtradas.length.toLocaleString("en-US")} resultados</span>
              <Button size="sm" color="secondary" outline disabled={pag <= 1} title="Primera pagina" onClick={() => setPagina(1)}>
                <i class="fas fa-angle-double-left"></i>
              </Button>
              <Button size="sm" color="secondary" outline disabled={pag <= 1} title="Pagina anterior" onClick={() => setPagina(pag - 1)}>
                <i class="fas fa-angle-left"></i>
              </Button>
              <span style={{ whiteSpace: "nowrap" }}>
                Pagina{" "}
                <Input
                  bsSize="sm"
                  type="number"
                  min={1}
                  max={totalPaginas}
                  value={pag}
                  title="Escribe la pagina a la que quieres ir"
                  onChange={(e) => {
                    const n = parseInt(e.target.value, 10);
                    if (n >= 1 && n <= totalPaginas) setPagina(n);
                  }}
                  style={{ width: 64, display: "inline-block", textAlign: "center" }}
                />{" "}
                de {totalPaginas}
              </span>
              <Button size="sm" color="secondary" outline disabled={pag >= totalPaginas} title="Pagina siguiente" onClick={() => setPagina(pag + 1)}>
                <i class="fas fa-angle-right"></i>
              </Button>
              <Button size="sm" color="secondary" outline disabled={pag >= totalPaginas} title="Ultima pagina" onClick={() => setPagina(totalPaginas)}>
                <i class="fas fa-angle-double-right"></i>
              </Button>
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <thead>
              <tr>
                <th>Ubicación</th>
                <th>Rack</th>
                <th>Pos.</th>
                <th>Nivel</th>
                <th>Reach</th>
                <th>Tipo</th>
                <th className="text-right">Tarimas</th>
                <th>Estado</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {visibles.map((u) => (
                <tr key={u._id}>
                  <td><b>{u.nombre}</b></td>
                  <td>{u.rack}</td>
                  <td>{u.posicion || ""}</td>
                  <td>{u.nivel || ""}</td>
                  <td>{u.reach}</td>
                  <td>{u.tipo}</td>
                  <td className="text-right">
                    {u.tarimasUsadas}/{Number(u.capacidadTarimas) ? u.capacidadTarimas : "∞"}
                  </td>
                  <td>
                    {u.llena ? (
                      <Badge color="danger" pill>Llena</Badge>
                    ) : u.tarimasUsadas > 0 ? (
                      <Badge color="warning" pill>Ocupada</Badge>
                    ) : (
                      <Badge color="success" pill>Libre</Badge>
                    )}
                  </td>
                  <td>
                    {u.tarimasUsadas > 0 ? (
                      <Button size="sm" color="info" title="Ver que articulos y cuantas piezas tiene" onClick={() => verContenido(u)}>
                        <i class="fas fa-eye"></i> Ver
                      </Button>
                    ) : null}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      ) : undefined}

      <Modal size="lg" isOpen={!!ubiVer} toggle={() => setUbiVer(null)}>
        <ModalHeader toggle={() => setUbiVer(null)}>
          Contenido de {ubiVer && ubiVer.nombre}
          {ubiVer ? (
            <small style={{ color: "#64748b", fontSize: 13, marginLeft: 8 }}>
              {ubiVer.tipo} · {ubiVer.tarimasUsadas}/{Number(ubiVer.capacidadTarimas) ? ubiVer.capacidadTarimas : "∞"} tarimas
            </small>
          ) : null}
        </ModalHeader>
        <ModalBody>
          {cargandoContenido ? (
            <div style={{ color: "#64748b" }}>Cargando…</div>
          ) : contenido.length ? (
            <Table size="sm" striped borderless>
              <thead>
                <tr>
                  <th>SKU</th>
                  <th>Articulo</th>
                  <th className="text-right">Tarimas</th>
                  <th className="text-right">Piezas</th>
                  <th className="text-right">Cajas</th>
                </tr>
              </thead>
              <tbody>
                {contenido.map((r) => (
                  <tr key={r._id}>
                    <td>{r.codigo}</td>
                    <td>{r.nombre}</td>
                    <td className="text-right">{r.tarimas || 1}</td>
                    <td className="text-right">{Number(r.cantidadAnterior || 0).toLocaleString("en-US")}</td>
                    <td className="text-right">
                      {Number(r.piezasPorCaja) > 0
                        ? Number((Number(r.cantidadAnterior) || 0) / Number(r.piezasPorCaja)).toLocaleString("en-US", { maximumFractionDigits: 1 })
                        : "—"}
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td colSpan={2} style={{ fontWeight: 600 }}>Total</td>
                  <td className="text-right" style={{ fontWeight: 600 }}>
                    {contenido.reduce((t, r) => t + (Number(r.tarimas) || 1), 0)}
                  </td>
                  <td className="text-right" style={{ fontWeight: 600 }}>
                    {contenido.reduce((t, r) => t + (Number(r.cantidadAnterior) || 0), 0).toLocaleString("en-US")}
                  </td>
                  <td></td>
                </tr>
              </tfoot>
            </Table>
          ) : (
            <div style={{ color: "#64748b" }}>Esta ubicacion no tiene mercancia en CEDIS.</div>
          )}
        </ModalBody>
        <ModalFooter>
          {ubiVer ? (
            <Button
              color="primary"
              title="Abrir el acomodo filtrado en esta ubicacion para mover su mercancia"
              href={`/AcomodoUbicaciones?ubicacion=${encodeURIComponent(ubiVer.nombre)}`}
            >
              <i class="fas fa-dolly"></i> Ir a acomodo
            </Button>
          ) : null}
          <Button color="secondary" onClick={() => setUbiVer(null)}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
}

export default CatalogoUbicaciones;
